import { Box, Grid, Typography } from '@mui/material';
import PackageCard from './PackageCard';
import { useSelector } from 'react-redux';
import PackagesDetailLineItems from './PackagesDetailLineItems';
import { useHistory } from 'react-router';
import { selectOnboardingApplicationState } from '../../../pmui/onboarding/sagas/pmonboardingSlice';
import { PricingPageStates } from '../../PricingV2';

export interface ChoosePackageProps {
  DoorCount: number;
}

export default function ChoosePackage(props: ChoosePackageProps) {
  const history = useHistory();
  const selectOnboardingState = useSelector(selectOnboardingApplicationState);

  return (
    <Box>
      <Typography sx={{ fontFamily: 'Work Sans !important', fontSize: 'large' }} margin={2}>
        Select your package:
      </Typography>
      <Grid container columnSpacing={10} rowSpacing={10}>
        {selectOnboardingState.productsPackagesV2?.Packages.map((pack) => {
          return (
            <Grid item xs={12} md={6} lg={4} key={pack.PackageUuid}>
              <PackageCard
                DoorCount={props.DoorCount}
                PackageDto={pack}
                Products={selectOnboardingState?.productsPackagesV2?.Products}
                IsCustom={pack.PackageMetadata?.IncludedProducts.length === 0}
                OnButtonClick={() => {
                  history.push(`/pricing/${PricingPageStates.ChoosePreferences}?packageUuid=${pack.PackageUuid}&doors=${props.DoorCount}`);
                }}
              />
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <PackagesDetailLineItems Packages={selectOnboardingState.productsPackagesV2?.Packages.filter((pkg) => pkg.PackageMetadata?.IncludedProducts.length > 0)} />
        </Grid>
      </Grid>
    </Box>
  );
}
